import { InjectionToken } from '@angular/core';

export interface VirtualScrollNodesProvider {
  /**
   * Returns the currently rendered DOM elements
   * @param root Host element
   */
  getDOMNodes: (root: ChildNode) => HTMLElement[];

  /**
   * Returns the index (starting from 0) of the element
   * @param element Node element
   */
  getIndexOfElement: (element: HTMLElement) => number;

  /**
   * Returns size (height/width) of the element
   * @param element
   */
  getSize: (element: HTMLElement) => number;
}

export const VIRTUAL_SCROLL_NODES_PROVIDER = new InjectionToken('VIRTUAL_SCROLL_NODES_PROVIDER');
